import { Component, EventEmitter, Output } from '@angular/core';

@Component({
  selector: 'app-create-2',
  imports: [],
  templateUrl: './create-2.component.html',
  styleUrl: './create-2.component.css',
})
export class Create2Component {
  @Output() stepChange = new EventEmitter<number>();

  handlePrevious() {
    this.stepChange.emit(1);
  }
}
